import { createFileRoute } from '@tanstack/react-router';
import { SiteManagementPage } from '@/features/sites';

export const Route = createFileRoute('/projects/$projectId/sites/$siteId')({
  component: SiteManagementPageWrapper,
});

function SiteManagementPageWrapper() {
  const { projectId, siteId } = Route.useParams();
  return (
    <SiteManagementPage
      searchParams={{ projectId: Number(projectId), siteId: Number(siteId) }}
    />
  );
}
